import React, { useState } from "react";
import { Table, Select, Input } from "antd";
import styles from "./StaffReciepe.module.css";
import { useNavigate } from "react-router-dom";
import { Dropdown, Modal, SubmitButton, TextComponent, SearchInput } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { SearchOutlined } from "@ant-design/icons";

const StaffReciepe = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [category, setCategory] = useState({
    value: "Category",
    role: "Category",
    id: 1,
  });

  const columns = [
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "Allergen Name",

      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Product Tag",
      dataIndex: "ProductTag",
      key: "Product Tag",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "Category",
      dataIndex: "Category",
      key: "Category",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (text) => (
    //     <Dropdown
    //       fontFamily={"poppins-medium"}
    //       value={text}
    //       inputStyle={{
    //         border: "transparent",
    //         // width: "70%",
    //         backgroundColor: "transparent",
    //       }}
    //       main_input={styles.mainInput}
    //       inputClass={styles.DropdownInput}
    //       style={{ color: "var(--black-color)" }}
    //       options={[
    //         {
    //           value: "View",
    //           role: "View",
    //           id: 1,
    //         },
    //         {
    //           value: "Edit",
    //           role: "Edit",
    //           id: 2,
    //         },
    //         {
    //           value: "Deactivate",
    //           role: "Deactivate",
    //           id: 3,
    //         },
    //       ]}
    //     />
    //   ),
    // },

    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"View"}
            btnClass={styles.tableBtn}
            primary
            onClick={() => navigate("/Staff/ViewRecipe")}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      ProductName: "French Batard Sliced",
      ProductTag: "System",
      LinkedRecipes: 1,
      Category: "Bread",
      LastModified: "Aug 01, 2025",
      action: "View",
    },
    {
      No: "2",
      ProductName: "Baguette",
      LinkedRecipes: 2,
      Category: "Bread",
      LastModified: "Aug 01, 2025",

      ProductTag: "System",
      action: "Edit",
    },
    {
      No: "  3   ",
      ProductName: "Multigrain bread",
      Category: "Assembly Only",
      LastModified: "Aug 01, 2025",

      ProductTag: "Custom",
      LinkedRecipes: 3,

      action: "View",
    },
    {
      No: "4",
      ProductName: "Pita bread",
      LinkedRecipes: 5,
      Category: "Assembly Only",
      LastModified: "Aug 01, 2025",

      ProductTag: "Custom",

      action: "View",
    },
    {
      No: "5",
      ProductName: "Sourdough",
      LinkedRecipes: 4,
      Category: "Assembly Only",

      LastModified: "Aug 01, 2025",
      action: "Deactivate",
      ProductTag: "Custom",
    },
    {
      No: "6",
      ProductName: "Pizza bread ",
      ProductTag: "Custom",
      LinkedRecipes: 2,
      Category: "Assembly Only",
      LastModified: "Aug 01, 2025",

      action: "View",
    },
  ];

  const categoryOpt = [
    {
      value: "Category",
      role: "Category",
      id: 1,
    },
    {
      value: "Bread",
      role: "Bread",
      id: 2,
    },
    {
      value: "General pastry",
      role: "General pastry",
      id: 3,
    },
    {
      value: "Vienoiserrie",
      role: "Vienoiserrie",
      id: 4,
    }, {
      value: "Assembly only",
      role: "Assembly only",
      id: 5,
    },
  ]


  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Recipe"}
        onSearch={(e) => setSearchTerm(e.target.value)}
        onSubmit={() => navigate("/RecipeManagement/CreateRecipe")}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={false}
        rightControlsStyle={styles.rightControlsStyle}
        onClickFilter={() => setFilterModal(true)}
        showSearch={true}
      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="staffId"
        />
      </div>


      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Product Tag"}

        />
        <Dropdown
          // label={"Category"}
          // labelClass={styles.DropDownLabel}
          value={category}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={categoryOpt}
          onChange={(e) => setCategory(e)}
        />
      </Modal>
    </div>
  );
};

export default StaffReciepe;
